import React from 'react';

import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {useBuildContextNodeEditabilityElement} from "../../Hooks/GenericModelHooks";
import {ContextNodeLink} from "./ContextNodeLink";
import {useFetchContextNode} from "../../Hooks/ContextHooks";

export const ContextNodeWithFullContextViewer = function (props) {
    
    const {contextNodeId, contextNode: contextNodeFromProps, userRoleId} = props;
    const contextNode = useFetchContextNode(contextNodeId, contextNodeFromProps);

    const context = ContextNodeService.GetSubtitle(contextNode);

    const buildContextNodeEditabilityElement = useBuildContextNodeEditabilityElement();
    const editability = buildContextNodeEditabilityElement(contextNode, userRoleId);

    return <div className="sb-context-node-viewer">
        <ContextNodeLink contextNode={contextNode}/>
        <div className="sb-autocomplete-subtext">{context}</div>
        {editability}
    </div>;
};
